module.exports = __webpack_public_path__ + "static/fipcwhitelambs4-ab8177259b0917698dd76ccbd93d5848.jpeg";